module.exports = __webpack_public_path__ + "static/media/matnrrd_2-775w.4375de03.png";